import React from 'react';
import CashFlowPredictor from '../../components/business/CashFlowPredictor';

/**
 * Dedicated Cash Flow Prediction Page
 * Advanced financial forecasting and cash management
 */
const AdminCashFlowPrediction = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">חיזוי תזרים מזומנים</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            חיזוי פיננסי מתקדם וניהול תזרים מזומנים חכם
          </p>
        </div>
        <div className="flex items-center space-x-3 mt-4 sm:mt-0">
          <div className="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
            <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse"></div>
            <span>חיזוי 12 חודשים</span>
          </div>
        </div>
      </div>

      {/* Full Cash Flow Predictor Component */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <CashFlowPredictor />
      </div>
    </div>
  );
};

export default AdminCashFlowPrediction;
